import React from 'react';
import { connect } from 'react-redux';

import { getTranslation } from '../../translation/translation';
import { trackVisit } from '../../logger/googleAnalytics';
import { renderOneImagePage } from '../../components/oneImagePage/oneImagePage';

interface PageNotFoundProp {
    textPageNotFound: string;
    textReason: string;
}

class PageNotFound extends React.Component<PageNotFoundProp> {
    public componentDidMount() {
        trackVisit('pagenotfound');
    }

    public render() {
        return renderOneImagePage('/seic_website/assets/image/illustration-404.png', this.props.textPageNotFound, this.props.textReason);
    }
}

const mapStateToProps = (state: any) => {
    return {
        textPageNotFound: getTranslation(state, 10),
        textReason: getTranslation(state, 11),
    };
}

export default connect(mapStateToProps)(PageNotFound);
export const PageNotFoundComponent = PageNotFound;